import type { Platform, ShareContent } from '../types';
import { PlatformRegistry } from './registry';

export const discord: Platform = {
  id: 'discord',
  name: 'Discord',
  iconIndex: PlatformRegistry.discord.index,
  color: PlatformRegistry.discord.color,
  buildUrl: (_content: ShareContent): string => {
    // Discord has no web share intent, link to app
    return 'https://discord.com/app';
  },
};

